import {Component, EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Configuration} from '../shared/services/configuration';
import {HttpClientCustom} from '../shared/services/http.client';
import * as _ from 'underscore';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Auth} from '../shared/services/auth';
import {Location} from '@angular/common';
import {SharedData} from '../shared/sharedData';
import {ToasterComponent} from '../toasterComponent/toasterComponent';
import {TranslateService} from '@ngx-translate/core';
import {isString} from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
  selector: 'AddDesignation',
  templateUrl: 'addDesignation.html'
})
export class AddDesignationComponent {
  @Input('parentOrg')
  public parentOrg: any;
  @Output() public addOrgEvent = new EventEmitter();
  public data: any;
  public cancelEvent: any = new EventEmitter();
  public myData: any;
  public arrayOfStrings = [];
  public categoryData: any = [];
  public myForm: FormGroup;
  public previousSearchKey;
  public orgTypeModel: any;
  public oldValue = null;
  public errorMessage: string;
  public successMessage: string;
  public desgdata: any = {};
  public _baseUrl: any;
  public type: any = 'ADD';
  public designationModel: any;
  public empPresent: boolean = false;

  // tslint:disable-next-line:member-ordering
  public payload = {
    searchString: '',
    excludeEmpIds: []
  };

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public _location: Location,
    public share: SharedData,
    public _toaster: ToasterComponent,
    public translate: TranslateService,
    vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    if (_.isEmpty(data)) {
      this._location.back();
    } else {
      if (data.type === 'ADD') {
        this.data = {};
        this.type = 'ADD';
      } else if (data.type === 'EDIT') {
        this.desgdata = data.desgData;
        this.type = 'EDIT';
      } else {
        this.desgdata = data.desgData;
        this.type = 'DELETE';
        let url = this._baseUrl + 'v1/webAdmin/designation/check/' + this.desgdata.id;
        this.http.get(url).subscribe((result) => {
          if (result.success) {
            this.empPresent = true;
          } else {
            this.empPresent = false;
          }
        });
      }
      this._toaster.setViewRef(vcr);
    }
  }

  // when auto-complete value is selected this method fires and payload create
  public gotNewValue(e, type) {
    this.designationModel = e;
  }

  // Formatter
  public nameValueFormatter(data: any): string {
    return `${data.name}`;
  }
  public orgNameValueFormatter(data: any): string {
    return `${data.orgName}`;
  }
  public autoCompleteListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  public autoCompleteListFormatterType = (data: any): SafeHtml => {
    let html = `<span>${data.type}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // To get list of designation based on keyword
  public designationObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword.trim()) {
      let url = this._baseUrl + 'v1/webAdmin/designation/designationSearch';
      url += '?searchString=' + keyword.trim() + '&id=' + this.desgdata.id;
      return this.http.get(url)
        .map((res) => {
          return res;
        }, (error) => {
          return Observable.of([]);
        });
    } else {
      return Observable.of([]);
    }
  }

  public autoCompleteListOrgTypeFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.orgUnitTypeName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // Navigate back
  public goToBackPage() {
    this._location.back();
  }

  public saveDesgData() {
    if (this.validateDesignation()) {
      let url = this._baseUrl + 'v1/webAdmin/designation/save';
      this.http.post(url, this.desgdata).subscribe((result) => {
        if (result.success) {
          this.translate.get('designationSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
          });
          setTimeout(() => this.goToBackPage(), 1000);
        } else {
          // this._toaster.showError('Error while adding Designation');
          this.translate.get(result.errorMessages[0]).subscribe((msg) => {
            this._toaster.showError(msg);
          });
        }
      }, (error) => {
        this.translate.get('errorWhileSavingDesignation').subscribe((msg) => {
          this._toaster.showError(msg);
        });
      });
    }
  }

  public rangeLimit(event) {
    if (event.target.value.length > 11) {
      event.target.value.slice(0, 10);
    }
  }

  public isEmpty(val) {
    return !val
      || (isString(val) && !val.trim());
  }

  public deleteDesgData() {
    if (this.empPresent && this.isEmpty(this.designationModel)) {
      this.translate.get('altDesigToContinue').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    let url;
    if (this.empPresent) {
      url = this._baseUrl + 'v1/webAdmin/designation/' + this.desgdata.id
        + '?alternateId=' + this.designationModel.id;
    } else {
      url = this._baseUrl + 'v1/webAdmin/designation/' + this.desgdata.id;
    }

    this.http.delete(url).subscribe((result) => {
      if (result.success) {
        this.translate.get('desigDeletedSuccessfully').subscribe((msg) => {
          this._toaster.showSuccess(msg);
        });

        setTimeout(() => this.goToBackPage(), 1000);
      } else {
        this.translate.get('erroeWhileDeteleDesig').subscribe((msg) => {
          this._toaster.showError(msg);
        });

        for (let val of result.errorMessages) {
          this._toaster.showError(val);
        }
      }
    });
  }

  public validateDesignation() {
    if (!this.desgdata.name || !this.desgdata.name.trim()) {
      this.translate.get('pleaseEnterNameToContinue').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.desgdata.code || !this.desgdata.code.trim()) {
      this.translate.get('pleaseEnterDesigCodeToContinue').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (!this.desgdata.level || this.desgdata.level < 1) {
      this.translate.get('pleaseEnterLevelGreaterThanZero').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    if (this.desgdata.level > 100) {
      this.translate.get('pleaseEnterLevelLessHund').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/tools/addDesignation.ts